import * as dayjs from 'dayjs'
import { Car, CheckCircle } from 'iconoir-react'

export const StatusNotification = ({ statusNotification }) => {
    return (
        <div className="flex w-full items-center ">
            {statusNotification.type === 'status_ongoing' ? (
                <Car className={'min-w-2-5 h-6 w-6 text-blue-500'} />
            ) : (
                <CheckCircle className={'min-w-2-5 h-6 w-6 text-green-500'} />
            )}
            <div className="flex flex-col pl-2 pr-1">
                <div className="wrapper text-notif flex text-left text-gray-700 ">
                    <a className={'font-bold capitalize'}>
                        {statusNotification.notifier.fullName}
                    </a>
                    <a>
                        {statusNotification.type === 'status_ongoing'
                            ? ' a pris en charge le transport de '
                            : ' a finalisé le transport de '}
                    </a>
                    <a className="capitalize underline">
                        {statusNotification.run.patient.fullName}
                    </a>
                </div>
                <p className="text-left text-xs text-gray-500">
                    {dayjs(statusNotification.createdAt).fromNow()}
                </p>
            </div>
            {!statusNotification.seen && (
                <div className="ml-auto">
                    <div className={`h-2 w-2 rounded-full bg-blue-500 `} />
                </div>
            )}
        </div>
    )
}
